import { Grid } from '@material-ui/core';
import React from 'react';
import { IItemDetails } from 'src/common/interfaces/dtos/IItemDetails';
import { styles } from './price-entry-styles';
import PriceVerificationRequiredSubText from './price-verification-required-subtext';
import { PriceEntryType } from 'src/common/enumerations/price-entry-type';
import { IMessageModal, MessageModalSizeEnum } from 'src/common/interfaces/dtos/IMessageModal';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { useTranslation } from 'react-i18next';

export const PRICE_VERIFICATION_MODAL = 'PRICE_VERIFICATION_MODAL';

export const showPriceVerificationDialog = (props: IPriceVerificationProps) => {
  showPriceVerificationModal(props);
};

export const TextContent = (props): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  return (
    <Grid item>
      <Grid container direction='column' justifyContent='space-between' style={{ height: '100%' }}>
        <Grid item>
          <Grid item className={classes.message}>
            <div
              className={classes.verifyTitle}
              data-testid={`${props.dataTestIdPrefix || 'p'}-dialog-message`}
            >
              {t('PriceVerifyRightView_VerifyPrice')}
            </div>
            <div
              className={classes.subMessage}
              data-testid={`${props.dataTestIdPrefix || 'p'}-dialog-submessage`}
            >
              {t('PriceVerifyRequired_Sub_Bar_Text')}
            </div>
            <Grid className={classes.padding}>
              <PriceVerificationRequiredSubText
                itemDetails={props.itemDetails}
                priceEntryType={props.priceEntryType}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const showPriceVerificationModal = (props: IPriceVerificationProps): void => {
  const modalConfig: IMessageModal = {
    type: EmeraldDialogTypes.Warning,
    onAccept: props.onAccept,
    onCancel: props.onReject,
    disableBackdropClick: true,
    acceptButtonLabel: 'Yes',
    closeButtonLabel: 'No',
    size: MessageModalSizeEnum.ExtraLarge,
    textContent: (
      <TextContent itemDetails={props.itemDetails} priceEntryType={props.priceEntryType} />
    ),
    modalId: PRICE_VERIFICATION_MODAL,
  };

  showEmeraldDialog(modalConfig);
};

export interface IPriceVerificationProps {
  onReject: () => void;
  onAccept: () => Promise<void>;
  itemDetails: IItemDetails;
  priceEntryType: PriceEntryType;
}
